var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPhoto48Line = function SvgIconPhoto48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 9.299H14.6a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3v-18.8c0-2.92-2.38-5.3-5.3-5.3Zm1.9 24.1a1.9 1.9 0 0 1-1.9 1.9H14.6a1.9 1.9 0 0 1-1.9-1.9v-18.8c0-1.05.85-1.9 1.9-1.9h18.8c1.05 0 1.9.85 1.9 1.9v18.8Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.51 23.119a2.91 2.91 0 0 0-5.08 0l-2.56 4.61-1.43-2.14a2.888 2.888 0 0 0-2.41-1.29c-.97 0-1.87.48-2.41 1.29l-1.73 2.6a2.9 2.9 0 0 0-.14 2.98c.5.95 1.49 1.53 2.56 1.53h13.6c1.04 0 1.97-.53 2.5-1.43.53-.89.54-1.97.04-2.88l-2.93-5.27h-.01Z",
    fill: "current"
  })));
};
export default SvgIconPhoto48Line;